module.exports = __webpack_public_path__ + "img/john-brown.a413c149.png";